import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as api from "../../redux/api";
import { reactIcons } from "../../utils/icons";

const CustomFileInput = ({
  label,
  allowedFormats,
  fileFormats = ["application/pdf"],
  defaultValue = [],
  onChange,
  name,
  disabled = false,
  ...props
}) => {
  const [uploadUrl, setUploadUrl] = useState(defaultValue || []);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  console.log({ name, defaultValue });
  useEffect(() => {
    setUploadUrl(defaultValue || []);
  }, [defaultValue]);
  console.log("defaultValue", defaultValue);

  const uploadFile = async (selectedFile) => {
    setIsLoading(true);
    if (!fileFormats.includes(selectedFile.type)) {
      setError("File type not allowed");
      setIsLoading(false);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", selectedFile);
      const response = await api.getFileUrl(formData);

      if (response.status && response.data?.url) {
        const newUrl = response.data.url;
        const updatedUrls = [...uploadUrl, newUrl];
        setUploadUrl(updatedUrls);
        onChange?.(updatedUrls);
        setError("");
      } else {
        setError(response?.error?.message || "Upload failed");
      }
    } catch (err) {
      setError("Upload failed");
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      Array.from(e.target.files).forEach((file) => {
        uploadFile(file);
      });
      e.target.value = "";
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      uploadFile(e.dataTransfer.files[0]);
      e.dataTransfer.clearData();
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDelete = (index) => {
    const updatedUrls = uploadUrl.filter((_, i) => i !== index);
    setUploadUrl(updatedUrls);
    onChange?.(updatedUrls);
  };

  return (
    <div className="w-full mb-5" {...props}>
      {label && <label className="block input-label mb-1">{label}</label>}
      {allowedFormats && (
        <label className="block input-label font-light text-12 mb-2">
          {allowedFormats}
        </label>
      )}

      <div
        className={`border border-primary-100 rounded p-6 flex flex-col items-center justify-center cursor-pointer relative ${
          disabled ? "opacity-50 pointer-events-none" : ""
        }`}
        onClick={() => {
          if (!isLoading && !disabled) {
            document.getElementById(`file-input-${name}`).click();
          }
        }}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        <div className="text-2xl">{reactIcons.fileImage}</div>
        <div className="font-semibold text-lg mb-1">Upload Document</div>
        <div className="text-sm text-gray-500">
          Drag & Drop your files or{" "}
          <span className="text-blue-500 underline">Browse</span>
        </div>

        <input
          id={`file-input-${name}`}
          type="file"
          className="hidden"
          onChange={handleFileChange}
          accept={fileFormats.join(",")}
          multiple
        />

        {isLoading && (
          <div className="ay-center ax-center w-full h-full z-30 backdrop-blur-md flex-center">
            <div className="shapes"></div>
          </div>
        )}
      </div>

      {uploadUrl?.length > 0 && (
        <div className="mt-2 grid grid-cols-1 gap-4 min-h-[100px]">
          {uploadUrl.map((item, index) => {
            const url = typeof item === "string" ? item : item?.url;
            const fileName =
              typeof item === "string"
                ? item?.split("/").pop()
                : item?.name || "File";
            const isPdf = url?.toLowerCase().endsWith(".pdf");

            return (
              <div
                key={index}
                className="relative flex justify-between border bg-[#356D280F] max-h-[40px]"
              >
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="h-full overflow-hidden flex justify-center   gap-6 items-center rounded text-center p-2"
                  onClick={(e) => e.stopPropagation()}
                >
                  {isPdf ? (
                    <p className="underline text-28 text-green-600">
                      {reactIcons.file}
                    </p>
                  ) : (
                    <p className="underline text-center text-28 text-green-600">
                      {reactIcons.file}
                    </p>
                  )}
                  <span className="text-12 break-all">{fileName}</span>
                </a>

                {!disabled && (
                  <button
                    onClick={() => handleDelete(index)}
                    className=" text-28 text-red-500  transition-all duration-200 rounded-full  flex items-center justify-center text-md  "
                  >
                    {reactIcons.delete}
                  </button>
                )}
              </div>
            );
          })}
        </div>
      )}

      {error && <div className="mt-2 text-red-500">{error}</div>}
    </div>
  );
};

CustomFileInput.propTypes = {
  label: PropTypes.string,
  allowedFormats: PropTypes.string,
  fileFormats: PropTypes.array,
  defaultValue: PropTypes.array,
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

export default CustomFileInput;
